import React, { useEffect, useState } from 'react';

import '@builder.io/widgets';
import { builder, BuilderComponent } from '@builder.io/react';
import { BUILDER_API_KEY } from 'src/scripts/utils/environment';
import ReactDOM from 'react-dom';
import { uniqueId } from 'lodash-es';
import { SHOP_LOCALE } from 'src/scripts/utils/constants';

// Init builder
// ? [REVISIT] Soon we should develop a way to ensure that we only init it once.
builder.init(BUILDER_API_KEY || 'DUMMY');
const PLPBuilderContent = ({ contentEntryId }: PLPBuilderContentOptions) => {
  const [randomUid] = useState(() => uniqueId('PLPBuilderContent_'));
  useEffect(() => {
    let myNode = document.getElementById(randomUid);
    console.log(randomUid);

    ReactDOM.render(<BuilderComponent model="plp-inline-block" entry={contentEntryId} locale={SHOP_LOCALE} />, myNode);
    return () => {
      if (myNode) ReactDOM.unmountComponentAtNode(myNode);
    };
  }, [contentEntryId, randomUid]);
  if (!BUILDER_API_KEY) return <div>Error: No builder API key!</div>;
  return <aside id={randomUid}></aside>;
};

export default PLPBuilderContent;

interface PLPBuilderContentOptions {
  contentEntryId: string;
}
